import IconAlert from '../../../../assets/dealroom-icons/alert.svg';
import IconAlertGray from '../../../../assets/dealroom-icons/alert-gray.svg';
import IconSummary from '../../../../assets/dealroom-icons/summary.svg';
import IconSummaryGray from '../../../../assets/dealroom-icons/summary-gray.svg';
import IconInvite from '../../../../assets/dealroom-icons/invite.svg';
import IconInviteGray from '../../../../assets/dealroom-icons/invite-gray.svg';
import IconChange from '../../../../assets/dealroom-icons/change.svg';
import IconChangeGray from '../../../../assets/dealroom-icons/change-gray.svg';
import IconChat from '../../../../assets/dealroom-icons/chat.svg';
import IconChatGray from '../../../../assets/dealroom-icons/chat-gray.svg';
import IconDownload from '../../../../assets/dealroom-icons/download.svg';
import IconDownloadGray from '../../../../assets/dealroom-icons/download-gray.svg';
import IconEmail from '../../../../assets/envelope.svg';
import IconEmailGray from '../../../../assets/envelope-gray.svg';

function previewIconLogic(isOwner) {
  let previewIcon = [
    [IconAlert, IconAlertGray, 'Terms summary.'],
    [
      IconSummary,
      IconSummaryGray,
      'Preview the entire agreement and see how your suggestions could change the entire agreement text.',
    ],
    [
      IconInvite,
      IconInviteGray,
      'Invite an attorney to review this agreement.',
    ],
    [IconChange, IconChangeGray, 'View all changes to this agreement.'],
    [IconChat, IconChatGray, 'Discuss this agreement with your collaborators.'],
    [IconDownload, IconDownloadGray, 'Download the current proposed version'],
  ];

  if (isOwner) {
    previewIcon = [
      ...previewIcon,
      [IconEmail, IconEmailGray, 'Resend invitation to members'],
    ];
  }

  return previewIcon;
}

export default previewIconLogic;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/previewIconLogic.js